// extracted by mini-css-extract-plugin
export default {"button":"PinWidgetButton_button__scIgd"};